/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTIONS_REQUEST_SUCCESS]: () => false,
        [actions.CONNECTIONS_REQUEST_FAILURE]: () => false,
        [actions.CONNECTIONS_REQUEST]: () => true,
    },
);



